(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_7d0cd34"] && !Shopify.designMode) return;
  try {
    (function() {
    class BenefitsCarousel extends HTMLElement {
      connectedCallback() {
        this.disconnectedCallback();
        this.controller = new AbortController();
        this.track = this.querySelector('[data-benefit-track]');
        this.items = [...this.querySelectorAll('[data-benefit-item]')];
        this.dots = [...this.querySelectorAll('[data-benefit-dot]')];
        this.viewport = this.querySelector('[data-benefit-viewport]');
        this.previous = this.querySelector('[data-direction="prev"]');
        this.next = this.querySelector('[data-direction="next"]');
        this.index = 0;
        this.loop = this.dataset.loop !== 'false';
        this.autoplay = this.dataset.autoplay === 'true';
        this.hovered = this.matches(':hover');
        this.focused = this.contains(document.activeElement);
        this.visible = !('IntersectionObserver' in window);
        this.delay = Math.max(2000, Number(this.dataset.delay) * 1000 || 5000);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const signal = this.controller.signal;
        this.querySelectorAll('[data-direction]').forEach((button) => button.addEventListener('click', () => this.move(button.dataset.direction === 'next' ? 1 : -1), { signal }));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), { signal }));
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => { this.update(); this.schedule(); }, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.1 });
          this.observer.observe(this);
        }
        this.update();
        this.schedule();
      }
      disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); }
      move(step) { this.goTo(this.loop ? (this.index + step + this.items.length) % this.items.length : Math.max(0, Math.min(this.items.length - 1, this.index + step))); }
      goTo(index) { if (index < 0 || index >= this.items.length) return; this.index = index; this.update(); this.schedule(); }
      schedule() {
        clearTimeout(this.timer);
        this.updateLiveRegion();
        if (!this.autoplay || this.hovered || this.focused || this.visible !== true || document.hidden || this.motion.matches || this.items.length < 2 || (!this.loop && this.index === this.items.length - 1)) return;
        this.timer = setTimeout(() => this.move(1), this.delay);
      }
      updateLiveRegion() {
        const completed = !this.loop && this.index === this.items.length - 1;
        if (this.viewport) this.viewport.setAttribute('aria-live', this.autoplay && !this.hovered && !this.focused && this.visible && !document.hidden && !this.motion.matches && !completed ? 'off' : 'polite');
      }
      update() {
        if (!this.track) return;
        this.track.style.transform = this.dataset.animation === 'slide' ? 'translateX(-' + (this.index * 100) + '%)' : '';
        this.items.forEach((item, index) => { item.dataset.active = String(index === this.index); item.setAttribute('aria-hidden', index === this.index ? 'false' : 'true'); item.inert = index !== this.index; });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
        if (this.previous) this.previous.disabled = !this.loop && this.index === 0;
        if (this.next) this.next.disabled = !this.loop && this.index === this.items.length - 1;
        this.updateLiveRegion();
      }
    }
    if (!customElements.get('benefits-carousel')) customElements.define('benefits-carousel', BenefitsCarousel);
  })();
  } catch(e) { console.error(e); }
})();

})();
